module.exports = __webpack_public_path__ + "img/birdroid.6cc8ee05.svg";